import React, { useContext, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/header/Navbar/Navbar";
import { Box } from "@mui/material";
import toast, { Toaster } from "react-hot-toast";
import { SocketContext } from "../context/SocketContext";
import CustomToast from "../components/ui/CustomToast";
import { SalesPersonIdContext } from "../context/SalesPersonContext";
import axios from "axios";
import apiClient from "../lib/api_client";
import { formatPermissions } from "../utils/formatRights";

const MainLayout = () => {
  const socket = useContext(SocketContext);
  const { salesPersonId } = useContext(SalesPersonIdContext);
  const location = useLocation();

  useEffect(() => {
    const path = location?.pathname;
    if (salesPersonId && path !== "/stock" && path !== "/Stock") {
      socket.on("select-update-request-message", (data) => {
        if (data?.salesPersonRef === salesPersonId) {
          return toast.custom((t) => (
            <CustomToast t={t} isError={false} message={data?.message} />
          ));
        }
      });
      socket.on("select-manager-received-force-request-message", (data) => {
        if (data?.salesPersonRef === salesPersonId) {
          return toast.custom((t) => (
            <CustomToast
              t={t}
              isError={false}
              message={data?.message}
              color={"yellow"}
            />
          ));
        }
      });
    }

    return () => {
      socket.off("select-update-request-message");
      socket.off("select-manager-request-message");
    };
  }, [salesPersonId]);

  useEffect(() => {
    const fetchRights = async () => {
      try {
        const response = await apiClient.get(
          `/getSelectPortalRightPageAccess`,
        );
        const rights = formatPermissions(response?.data?.data?.subRights);
        localStorage.setItem("rights",JSON.stringify(rights));
        window.dispatchEvent(new Event("rights-updated"));
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchRights();
  }, []);

  return (
    <>
      {/* header */}
      <Navbar />
      {/* mainSection */}
      <Box marginTop="10vh">
        <Toaster position="top-right" />
        <Outlet />
      </Box>
    </>
  );
};

export default MainLayout;
